export default "https://cdn-static.gokick.com/assets/f3c431ab621bc71377aad81f5421d83f1421a0d2/images/sleep-bottles.21ff427124b73aa7b2cf5884e65ef589.jpg";